import AddOutlayModal from './add-outlay-modal.vue'
export default AddOutlayModal
